import { useMemo } from "react";

export const autoSizeColumns = ref => {
	if (ref?.current) return ref?.current?.api?.sizeColumnsToFit?.();
	return ref?.api?.sizeColumnsToFit();
};

export const filterGrid = (ref, filter) => ref?.current?.api?.setGridOption?.("quickFilterText", filter);

export const getFilteredRowCount = ref => ref?.current?.api?.getDisplayedRowCount?.();

export const gridContainerProps = (theme) => {
	return {
		className: `ag-theme-alpine${(theme === 'light' ? '' : `-${theme}`)} bg-${theme} mb-2`,
		style: {
			height: 700,
			width: '100%',
		}
	}
}

export const useDefaultColDef = () => useMemo(() => {
	return {
		// minWidth: 100,
		// make every column editable
		// editable: true,
		aggFunc: "sum",
		filter: 'agSetColumnFilter',
		sortable: true,
		resizable: true,
		enableRowGroup: true,
		suppressHeaderFilterButton: true,
		// ...config,
	};
}, []);

export const onBtnExport = (gridRef, fileName) => {
	const params = {
		fileName
	}
	if (gridRef?.current) return gridRef.current.api.exportDataAsCsv(params);
	return gridRef.api.exportDataAsCsv(params)
};

export const recursiveRowNodeSearch = (rowNode) => {
	let arr = [];
	let uniqueRnKeys = {};
	if (rowNode.childrenAfterFilter) {
		rowNode.childrenAfterFilter.forEach(datum => {
			arr = arr.concat(recursiveRowNodeSearch(datum));
		});
	}
	else if (rowNode.allLeafChildren) {
		rowNode.allLeafChildren.forEach(datum => {
			arr = arr.concat(recursiveRowNodeSearch(datum));
		});
	}
	else if (rowNode.data) {
		if (!uniqueRnKeys.hasOwnProperty(rowNode.id)) {
			uniqueRnKeys[rowNode.id] = true;
			arr.push(rowNode.data);
		}
	}
	return arr;
}
